import { useApiMutation } from '../../queries/useApiMutation';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { del } from '../../queries';

export const useRemoveFavouriteEventMutation = () => {
    const mutation = useApiMutation<{ userId: string; eventId: string }>({
        mutationFn: ({ userId, eventId }) => del(`users/${userId}/favourites/${eventId}`, undefined),
        onManualCacheUpdate: (queryClient, _response, args) => {
            setQueryDataSafe<string[]>(queryClient, queryKeys.users.favourites(args.userId), (previous) =>
                previous.filter((id) => id !== args.eventId)
            );
        },
    });

    return mutation;
};
